<template>
  <footer :class="'site-footer ' + variant" vb-background-extra1>
    <b-container>
      <div class="site-footer__wrapper">
        <!--<div class="site-footer__logo">
          <slot name="logo"></slot>
        </div>-->
        <b-row>
          <slot name="columns"></slot>

          <b-col v-if="!support_flow_enabled" sm="6" md="3">
            <div class="h6 site-footer__title">
              <!--{{ get_config('site.brand', '') }}-->
              Legal
            </div>
            <ul class="site-footer__links">
              <li
                v-for="(link, index) in site_footer_links"
                :key="`${index}:${link.text}`"
                class="site-footer__link"
              >
                <component :is="link.component" v-bind="link.props || {}">
                  {{ link.text }}
                </component>
              </li>
            </ul>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </footer>
</template>

<script>
import { is_support_flow_enabled } from "@/utilities/support_enabled";

export default {
  name: "site-footer",
  components: {},
  props: {
    variant: {
      type: String,
      default: "light",
    },
  },
  created() {},
  computed: {
    support_flow_enabled: () => is_support_flow_enabled(),
    site_footer_links() {
      const { site: site_config = {} } = this.get_config() || {};
      const links = [
        {
          component: "router-link",
          props: {
            to: { name: "terms" },
          },
          text: "Termini e condizioni",
        },
      ];
      if (site_config.urlPrivacy) {
        links.push({
          component: "a",
          props: {
            href: site_config.urlPrivacy,
            target: "_blank",
          },
          text: "Privacy Policy",
        });
      }
      if (site_config.urlCookiePolicy) {
        links.push({
          component: "a",
          props: {
            href: site_config.urlCookiePolicy,
            target: "_blank",
          },
          text: "Cookie Policy",
        });
      }
      
      // TODO: this is not stable and reliable make sure to discriminate between sites in other ways
      if (String(site_config.brand).toLowerCase() !== 'vivamod') {
        // TODO: once every portal adopts /contatti this becomes the default and the about#contattaci fallback goes away
        links.push({
          component: "router-link",
          props: {
            to: this.support_flow_enabled
              ? { name: "contatti" }
              : { name: "about", hash: "#contattaci" },
          },
          text: "Contatti",
        });
      }

      return links;
    },
  },
  watch: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss">
.site-footer {
  background: $white;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  margin-top: $grid-gutter-width * 2;
  padding-top: $grid-gutter-width * 2;
  text-align: center;

  @include media-breakpoint-up(sm) {
    text-align: left;
  }

  & > .container,
  & > .container-fluid {
    flex: 1;
  }

  &__wrapper {
    border-radius: $border-radius;
  }

  &__logo {
    padding-bottom: $grid-gutter-width;
    max-width: 100px;
    margin: auto;

    @include media-breakpoint-up(sm) {
      padding-bottom: $grid-gutter-width * 2;
      margin: 0;
    }
  }

  &__title {
    display: block;
    padding-bottom: $grid-gutter-width;
  }

  &__links {
    list-style: none;
    padding: 0;
    margin-bottom: $grid-gutter-width * 2;
  }

  &__link {
    padding: 0;
    margin: 0 0 $grid-gutter-width/2 0;
    font-size: 0.8125rem;
    * {
      color: $vb-body-color;
      &:active,
      &:hover,
      &:focus,
      &:visited {
        color: $vb-body-color;
      }
    }
  }

  &.dark {
    background-color: $primary;
    color: $light;
    .site-footer__link * {
      color: $light;
      &:active,
      &:hover,
      &:focus,
      &:visited {
        color: $light;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media print {
    display: none;
  }
}
</style>
